enum EnrollmentTypeEnum {
  RegularEnrollment = 1,
  SubsequentEnrollment = 2,
}

export default EnrollmentTypeEnum;
